import {Table} from 'letrus-ui';
import styles from './OrthographicDeviationsTable.module.scss';
import {OrthographicDeviation} from '..';

function OrthographicDeviationsTable({orthographicDeviations}): JSX.Element {
  return (
    <Table.Container className={styles.tableContainer}>
      <Table.Header headings={['Desvios', 'Correções', 'Comentários']} />
      <tbody>
        {orthographicDeviations?.map(
          (orthographicDeviation: OrthographicDeviation) => {
            return (
              <tr key={orthographicDeviation.text}>
                <td>{orthographicDeviation.text}</td>
                <td>{orthographicDeviation.suggested_text}</td>
                <td
                  dangerouslySetInnerHTML={{
                    __html: orthographicDeviation.comment,
                  }}
                />
              </tr>
            );
          },
        )}
      </tbody>
    </Table.Container>
  );
}

export default OrthographicDeviationsTable;
